// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"424a91e8","455":"913d924d","977":"1459616d"}[chunkId] + ".chunk.js";
};